import type { ComponentType } from 'react';
import type { AppletId } from './appletRegistry';

export type AppletModule = {
  App: ComponentType;
  applyActiveTemplate: () => unknown;
  applyResolvedTemplate: (templateType: unknown, companyLogo?: unknown) => unknown;
  APPLET_ID: AppletId;
};

export async function loadAppletModule(id: AppletId): Promise<AppletModule> {
  switch (id) {
    case 'arva':
      return import('@applet-arva/bootstrap') as Promise<AppletModule>;
    case 'saye-saman':
      return import('@applet-saye-saman/bootstrap') as Promise<AppletModule>;
    case 'nsight':
    default:
      return import('@applet-nsight/bootstrap') as Promise<AppletModule>;
  }
}
